import { render, staticRenderFns } from "./SKPTambahan.vue?vue&type=template&id=0c1340a4&scoped=true&"
import script from "./SKPTambahan.vue?vue&type=script&lang=js&"
export * from "./SKPTambahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1340a4",
  null
  
)

export default component.exports